var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 37,
    viewBox: "0 0 64 37",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-14h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.88 11.483H64v21.69h-5.12l-5.12-3.828H51.2v5.623A2.035 2.035 0 0 1 49.162 37H10.998a2.035 2.035 0 0 1-2.038-2.032V20.414H3.82a1.363 1.363 0 0 1-1.354 1.276H1.374A1.363 1.363 0 0 1 .02 20.414H0v-8.931h.02c.05-.71.629-1.276 1.354-1.276h1.092c.725 0 1.304.566 1.355 1.276H8.96v-.52c0-1.122.913-2.032 2.038-2.032h23.348l-1.634-5.103H16c-1.06 0-1.92-.857-1.92-1.914S14.94 0 16 0h17.59a2.16 2.16 0 0 1 1.558.668l8.213 8.263h5.8c1.126 0 2.039.91 2.039 2.032v14.554c1.067 0 1.76-3.934 1.76-8.133l5.92-5.901zm-25.6 20.414V21.69H15.36v10.207h17.92z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.c9bd9945ac59beff540ebe206b431f9e.svg";
export { ForwardRef as ReactComponent };